<template>
  <div>
    <div>
      <div class="row">
        <div class="col-9">
          <label for="exampleFormControlSelect1"
            ><h5>
              *
              <span
                >학생(아동) 목록<span style="font-size: 12px">(가나다순)</span></span
              >
            </h5></label
          >
        </div>
        <div class="col-3" style="text-align: right">
          <span
            ><button
              type="button"
              class="btn btn-primary btn-sm"
              @click="AddMember"
              v-show="$store.state.role == 4 || $store.state.role == 1"
            >
              등록
            </button>
          </span>
        </div>
      </div>

      <div>
        <select
          class="form-control"
          id="gradegroup"
          name="gradegroup"
          v-model="gradegroup"
          @change="getGradeGroup()"
          v-show="this.role < 5"
        >
          <option id="" value="00">조회 대상을 선택하세요.</option>
          <option
            v-for="gradelist in gradegrouplist"
            :key="String(gradelist.teacherid) + '-' + String(gradelist.grade != null ? gradelist.grade : '')"
            v-bind:value="gradelist.grade"
            :id="gradelist.grade"
          >
            {{ studentListGradeLabel(gradelist) }}
          </option>
        </select>
      </div>
      <p></p>
      <div class="tab-content" id="myTabContent">
        <!-- 부서(팀)검색 -->
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <!-- 리스트 시작 -->
          <div
            v-if="getManageList.length > 0"
            class="accordion"
            id="accordionExample"
          >
            <div
              class="card"
              v-for="manageList in getManageList"
              :key="manageList.no"
            >
              <div class="card-header" :id="'headingOne' + manageList.no">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link btn-block text-left"
                    type="button"
                    data-toggle="collapse"
                    :data-target="'#collapseOne' + manageList.no"
                    aria-expanded="true"
                    :aria-controls="'#collapseOne' + manageList.no"
                    style="text-decoration-line: none"
                  >
                    <!-- <span style="color: #1d2124">
                         </span
                      ><span style="color: #dee2e6">|</span> -->
                    {{ manageList.name }}({{ manageList.sex }})
                    <span style="color: #dee2e6">|</span>
                  </button>
                </h2>
              </div>
              <div
                :id="'collapseOne' + manageList.no"
                class="collapse"
                :aria-labelledby="'headingOne' + manageList.no"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item" style="background: ghostwhite">
                      <div class="row">
                        <div class="col" style="font-size: 20px">
                          <b>{{ manageList.name }} </b>
                        </div>
                        <div
                          v-if="manageList.photo2 !== null"
                          class="col"
                          style="text-align: right; padding-left: 0; padding-right: 0"
                        >
                          <div
                            style="
                              display: inline-flex;
                              align-items: center;
                              cursor: pointer;
                            "
                            @click="updatePhoto(manageList)"
                          >
                            <img
                              :src="photourl(manageList.photo2)"
                              alt="..."
                              style="
                                width: 70%;
                                padding: 0;
                                margin: 0;
                                border: none;
                                border-radius: 0;
                                display: block;
                              "
                            />
                            <div
                              style="
                                font-size: 10px;
                                color: #6c757d;
                                margin-left: 4px;
                              "
                            >
                              변경
                            </div>
                          </div>
                        </div>
                        <div
                          v-else-if="manageList.photo !== null"
                          class="col"
                          style="text-align: right; padding-left: 0; padding-right: 0"
                        >
                          <div
                            style="
                              display: inline-flex;
                              align-items: center;
                              cursor: pointer;
                            "
                            @click="updatePhoto(manageList)"
                          >
                            <img
                              :src="photourl(manageList.photo)"
                              alt="..."
                              style="
                                width: 70%;
                                padding: 0;
                                margin: 0;
                                border: none;
                                border-radius: 0;
                                display: block;
                              "
                            />
                            <div
                              style="
                                font-size: 10px;
                                color: #6c757d;
                                margin-left: 4px;
                              "
                            >
                              변경
                            </div>
                          </div>
                        </div>
                        <div
                          v-else
                          class="col"
                          style="text-align: right; padding-left: 0; padding-right: 0"
                        >
                          <div
                            style="
                              display: inline-flex;
                              align-items: center;
                              cursor: pointer;
                            "
                            @click="updatePhoto(manageList)"
                          >
                            <img
                              src="../assets/noimage.png"
                              style="
                                width: 40%;
                                padding: 0;
                                margin: 0;
                                border: none;
                                border-radius: 0;
                                display: block;
                              "
                            />
                            <div
                              style="
                                font-size: 10px;
                                color: #6c757d;
                                margin-left: 4px;
                              "
                            >
                              변경
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <b>1. 학년:</b>
                      {{ manageList.gradename }}
                    </li>
                    <li class="list-group-item">
                      <b>2. 생년월일:</b>
                      {{ manageList.birthday }}
                    </li>
                    <li class="list-group-item">
                      <b>3. 연락처</b>: {{ manageList.phone }}
                    </li>
                    <!-- <li class="list-group-item">3. 전파자: {{manageList.spreader}}</li> -->
                    <li class="list-group-item">
                      <b>4. 학부모 연락처</b>: {{ manageList.parentphone }}
                    </li>
                    <li class="list-group-item">
                      <b>5. 주소</b>: {{ manageList.address }}
                    </li>
                    <li class="list-group-item">
                      <b>6. 학교</b>: {{ manageList.school }}
                    </li>
                    <li class="list-group-item">
                      <b>7. 참고사항</b>: {{ manageList.rmk }}
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <div class="row justify-content-end">
                            <div class="col-auto" v-show="canEditStudent(manageList)">
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm btn-block"
                                @click="openStudentInfo(manageList)"
                              >
                                학생정보
                              </button>
                            </div>
                            <div class="col-auto" v-show="canEditStudent(manageList)">
                              <button
                                type="button"
                                class="btn btn-outline-success btn-sm btn-block"
                                @click="openTeacherOpinion(manageList)"
                              >
                                교사소견
                              </button>
                            </div>
                            <div class="col-auto">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm btn-block"
                                @click="UpdateMember(manageList)"
                              >
                                수정
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="accordion" id="accordionExample">
            <div class="card">
              <h2 class="mb-0">
                <button class="btn btn-block text-left">
                  조회된 학생(아동) 자료가 없습니다.
                </button>
              </h2>
            </div>
          </div>
          <!-- 리스트 종료 -->
          <!-- pgaination -->
          <!-- <div style="padding-top: 20px">
              <paginate
                :pageCount="pageTotalCount"
                :clickHandler="clickCallback"
                :prevText="'Prev'"
                :nextText="'Next'"
                :containerClass="'pagination'"
              >
              </paginate>
            </div> -->
          <!-- pgaination -->
        </div>
      </div>
    </div>
    <!-- 등록/수정 -->
    <div
      class="modal fade"
      id="memberAddModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="memberAddModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="memberAddModalLabel"
              style="color: blue"
            >
              <span id="plpmo"></span>
              <div v-if="isNew">학생(아동) 신규 등록</div>
              <div v-else>학생(아동) 정보 수정</div>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <form
                id="addMemberform"
                name="addMemberform"
                v-on:submit="addMemberForm"
              >
                <!-- 선생님 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>선생님</h6>
                    </div>
                    <div class="col-9">
                      <select
                        class="form-control"
                        id="formteacherid"
                        name="formteacherid"
                        v-model="selectedClassGrade"
                        style="width: 80%"
                        :disabled="$store.state.role === '2' || $store.state.role === '3' || $store.state.role === '5' || $store.state.role === '9'"
                        @change="searchclassinfo($event)"
                      >
                        <option
                          v-for="teacher in teachers"
                          :key="String(teacher.teacherid) + '-' + String(teacher.grade)"
                          v-bind:value="teacher.grade"
                          :id="teacher.teacherid"
                          :data-gradename="teacher.gradename"
                          :data-teacherid="teacher.teacherid"
                        >
                          {{ teacherSelectLabel(teacher) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- 학년 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>학년/반</h6>
                    </div>
                    <div class="col-9">
                      {{ form.gradename }}
                    </div>
                  </div>
                </div>

                <!-- 반 -->
                 <!--
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>반</h6>
                    </div>
                    <div class="col-9">
                      <select
                        class="custom-select"
                        id="formgradediv"
                        name="formgradediv"
                        v-model="form.gradediv"
                        style="width: 60%"
                        :disabled="role > 1 && !isNew"
                      >
                        <option value="1">1반</option>
                        <option value="2">2반</option>
                        <option value="3">3반</option>
                        <option value="4">4반</option>
                        <option value="5">5반</option>
                        <option value="6">6반</option>
                        <option value="7">7반</option>
                        <option value="0">새가족</option>
                        <option value="9">선생님</option></select
                      >← 반 선생님 확인
                    </div>
                  </div>
                </div>-->
                <!-- 이름 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>이름</h6>
                    </div>
                    <div class="col-9">
                      <input
                        type="text"
                        class="form-control"
                        id="formname"
                        v-model="form.name"
                        name="formname"
                        autocomplete="off"
                        placeholder=""
                        style="width: 60%"
                      />
                    </div>
                  </div>
                </div>

                <!-- 성별 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>성별</h6>
                    </div>
                    <div class="col-9">
                      <select
                        class="custom-select"
                        id="formsex"
                        name="formsex"
                        v-model="form.sex"
                        style="width: 40%"
                      >
                        <option value="남">남</option>
                        <option value="여">여</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- 생년월일 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>생년월일</h6>
                    </div>
                    <div class="col-9">
                      <input
                        type="text"
                        class="form-control"
                        id="formbirthday"
                        v-model="form.birthday"
                        name="formmemberno"
                        autocomplete="off"
                        placeholder="ex) 20041230"
                        style="width: 60%"
                      />
                    </div>
                  </div>
                </div>
                <!-- 연락처 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>연락처</h6>
                    </div>
                    <div class="col-9">
                      <input
                        type="text"
                        class="form-control"
                        id="formphone"
                        v-model="form.phone"
                        name="formphone"
                        autocomplete="off"
                        placeholder="010-0000-0000"
                        style="width: 60%"
                      />
                    </div>
                  </div>
                </div>
                <!-- 학부모 연락처 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-4">
                      <h6>부모연락처</h6>
                    </div>
                    <div class="col-8">
                      <input
                        type="text"
                        class="form-control"
                        id="formparentphone"
                        v-model="form.parentphone"
                        name="formparentphone"
                        autocomplete="off"
                        placeholder="010-0000-0000"
                        style="width: 80%"
                      />
                    </div>
                  </div>
                </div>
                <!-- 주소 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>주소</h6>
                    </div>
                    <div class="col-9">
                      <textarea
                        type="text"
                        class="form-control"
                        id="formaddress"
                        name="formaddress"
                        v-model="form.address"
                        autocomplete="off"
                        placeholder=""
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <!-- 학교 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>학교</h6>
                    </div>
                    <div class="col-9">
                      <input
                        type="text"
                        class="form-control"
                        id="formschool"
                        name="formschool"
                        v-model="form.school"
                        autocomplete="off"
                        placeholder=""
                        style="width: 80%"
                      />
                    </div>
                  </div>
                </div>
                <!-- 참고사항 -->
                <div class="form-group mx-sm-3 mb-2">
                  <div class="row" style="align-items: baseline">
                    <div class="col-3">
                      <h6>참고사항</h6>
                    </div>
                    <div class="col-9">
                      <textarea
                        type="text"
                        class="form-control"
                        id="formrmk"
                        name="formrmk"
                        v-model="form.rmk"
                        autocomplete="off"
                        placeholder=""
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <div class="container">
                    <div class="row">
                      <div class="col-sm">
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          data-toggle="modal"
                          data-target="#memberDeleteModal"
                        >
                          탈퇴처리
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          v-if="isNew"
                          @click="setMember(1)"
                          style="margin-left: 20px"
                        >
                          등록
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          v-else
                          @click="setMember(2)"
                          style="margin-left: 20px"
                        >
                          수정
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          data-dismiss="modal"
                          @click="modalClose"
                          style="margin-left: 20px"
                        >
                          닫기
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 사진 등록 -->
    <div
      class="modal fade"
      id="memberPhotoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="memberPhotoModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="memberPhotoModalLabel"
              style="color: blue"
            >
              <span id="plpmo"></span>
              <div>{{ photoitem.name }} 사진 등록</div>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <!-- 선생님 -->
              <!-- 참고사항 -->
              <div v-if="photoitem.photo !== null" class="form-group mx-sm-3 mb-2">
                  <small class="text-muted">만나 등록 사진</small>
                <div class="d-flex align-items-start">
                  <img :src="photourl(photoitem.photo)" alt="..." class="img-thumbnail" />
                  <button
                    v-show="$store.state.role == 4 || $store.state.role == 1"
                    type="button"
                    class="btn btn-danger btn-sm ml-2"
                    @click="deletePhoto(1, photoitem.no)"
                  >
                    X
                  </button>
                </div>
              </div>

              <div v-if="photoitem.photo2 !== null" class="form-group mx-sm-3 mb-2">
                  <small class="text-muted">출석부 촬영 사진</small>
                <div class="d-flex align-items-start">
                  <img :src="photourl(photoitem.photo2)" alt="..." class="img-thumbnail" />
                  <button
                    v-show="$store.state.role == 4 || $store.state.role == 1"
                    type="button"
                    class="btn btn-danger btn-sm ml-2"
                    @click="deletePhoto(2, photoitem.no)"
                  >
                    X
                  </button>
                </div>
              </div>
              <div
                v-else
                class="form-group mx-sm-3 mb-2"
                style="text-align: center"
              >
                <img src="../assets/noimage.png" style="width: 20%" />
              </div>
              <div class="mb-3">
                <form ref="addFileForm">
                  <input
                    type="file"
                    ref="files"
                    @change="fileUpload"
                    class="form-control"
                    style="height: 45px"
                  />

                  <div v-if="fileArray.length > 0">
                    <div
                      class="ml-2 mt-1 d-flex justify-content-between"
                      v-for="(data, index) in fileArray"
                      :key="'file' + index"
                    ></div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="savePhoto()"
                >
                  저장
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closePhotoModal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 학생정보 모달 -->
    <div
      class="modal fade"
      id="studentInfoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="studentInfoModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="studentInfoModalLabel" style="color: blue">
              {{ currentStudentName }} 학생정보
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>특기, 취미</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="3" v-model="extraForm.hobby" placeholder="예시) 특기-그림그리기, 취미-애니메이션시청, 축구"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>친한친구</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="2" v-model="extraForm.bestfriend" placeholder="예시) 김동안(열매2부), 이교회(소망1부)"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>주의사항</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="3" v-model="extraForm.caution" placeholder="예시) 못먹는음식, 알레르기, 행동 특성 등"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>예배출석</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="2" v-model="extraForm.worship_attendance" placeholder="예시) 상, 중, 하"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>분반참여도</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="2" v-model="extraForm.class_participation" placeholder="예시) 상, 중, 하"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" @click="saveStudentInfo">저장</button>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="modalClose">닫기</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 교사소견 모달 -->
    <div
      class="modal fade"
      id="teacherOpinionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="teacherOpinionModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="teacherOpinionModalLabel" style="color: blue">
              {{ currentStudentName }} 교사소견
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>가정환경</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="3" v-model="extraForm.home_env" placeholder="예시) 부모님 신앙생활, 가정예배, 주중 참여도, 주일 픽업시간 등"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>학생특징</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="3" v-model="extraForm.student_characteristics" placeholder="예시) 후임 담임교사가 꼭 알아야 할 내용을 적어주세요. 개인 특징, 정서적 특징, 상황 등"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group mx-sm-3 mb-2">
              <div class="row" style="align-items: baseline">
                <div class="col-4"><h6>종합적 소견</h6></div>
                <div class="col-8">
                  <textarea class="form-control" rows="4" v-model="extraForm.overall_opinion" placeholder="예시) 반편성 및 담당교사 배정 시 도움이 되는 내용을 적어주세요. 현 담임교사의 종합적 소견"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" @click="saveTeacherOpinion">저장</button>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="modalClose">닫기</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 탈퇴 모달 -->
    <div
      class="modal fade"
      id="memberDeleteModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">탈퇴 처리</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">탈퇴 처리하시겠습니까?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              닫기
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="removemember(form)"
            >
              탈퇴 요청
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import manageService from "../services/manageService";
  //import moment from "moment";
  import $ from "jquery";
  import { mapState } from "vuex";

  export default {
    name: "list",
    components: {},
    data() {
      return {
        manageLists: {},
        page: 40, //보여줄 항목
        current_page: 0,
        manageListLimit: {},
        pageTotalCount: 0,
        form: {
          name: "",
          sex: "",
          birthday: "",
          phone: "",
          groupid: "",
          gradediv: "",
          parentphone: "",
          address: "",
          rmk: "",
          school: "",
          no: "",
          teacherid: this.$store.state.teacherid,
          grade: this.$store.state.grade,
          classid: this.$store.state.classid,
          gradename: "",
        },
        isNew: true,
        teachers: {},
        photoitem: {},
        file: "",
        fileArray: [],
        id: this.$store.state.id,
        grade: this.$store.state.grade,
        phone: this.$store.state.phone,
        name: this.$store.state.name,
        teacherid: this.$store.state.teacherid,
        role: this.$store.state.role,
        token: this.$store.state.token,
        classid: this.$store.state.classid,
        gradegrouplist: {},
        gradegroup: "00",
        selectedClassGrade: "",
        classinfo: {},
        // 학생 추가정보
        extraForm: {
          student_no: '',
          hobby: '',
          bestfriend: '',
          caution: '',
          worship_attendance: '',
          class_participation: '',
          home_env: '',
          student_characteristics: '',
          overall_opinion: '',
        },
        currentStudentName: '',
      };
    },
    computed: {
      ...mapState(["isLogin", "userInfo"]),
      getManageList: function () {
        return this.manageLists;
      },

      photourl() {
        return (url) => {
          return "./upload/photo/" + url;
        };
      },
    },
    methods: {
      gradeListLabel(g) {
        if (!g) return "";
        if (g.listlabel != null && g.listlabel !== "") return g.listlabel;
        const a = (g.gradename != null ? String(g.gradename) : "").trim();
        const b = (g.teachername != null ? String(g.teachername) : "").trim();
        const hideNames = ["선생님", "새가족", "새친구", "새얼굴"];
        if (hideNames.includes(a)) return a;
        if (a && b) return `${a} ${b}`;
        return a || b;
      },
      studentListGradeLabel(g) {
        const base = (g && g.gradename != null ? String(g.gradename) : "").trim();
        if (!base) return "";
        return base.replace(/^(\d+학년)(\d+반)$/, "$1 $2");
      },
      teacherSelectLabel(teacher) {
        if (!teacher) return "";
        if (teacher.listlabel != null && teacher.listlabel !== "") {
          return teacher.listlabel;
        }
        if (teacher.display_label != null && teacher.display_label !== "") {
          return teacher.display_label;
        }
        const group = (teacher.gradename != null ? String(teacher.gradename) : "").trim();
        const name = (teacher.teachername != null ? String(teacher.teachername) : teacher.name != null ? String(teacher.name) : "").trim();
        const hideNames = ["선생님", "새가족", "새친구", "새얼굴"];
        if (hideNames.includes(group)) return group;
        if (group && name) return `${group} ${name}`;
        return group || name;
      },
      getLoginTeacherId() {
        // 우선 localStorage.userData 에서 teacherid 사용, 없으면 스토어 값으로 폴백
        try {
          const raw = localStorage.getItem('userData');
          if (raw) {
            const obj = JSON.parse(raw);
            if (obj && obj.teacherid) {
              return String(obj.teacherid);
            }
          }
        } catch (e) {
          // ignore and fallback
        }
        return String(this.teacherid || '');
      },
      canEditStudent(item) {
        // 관리자(1)는 항상 가능, 담임(3)는 자신의 반(grade)만 가능
        return this.role === '1' || (this.role === '3' && this.grade === item.grade);
      },
      resetExtraForm() {
        this.extraForm.student_no = '';
        this.extraForm.hobby = '';
        this.extraForm.bestfriend = '';
        this.extraForm.caution = '';
        this.extraForm.worship_attendance = '';
        this.extraForm.class_participation = '';
        this.extraForm.home_env = '';
        this.extraForm.student_characteristics = '';
        this.extraForm.overall_opinion = '';
      },
      loadStudentExtra(studentNo) {
        this.resetExtraForm();
        this.extraForm.student_no = studentNo;
        manageService
          .getStudentExtra({ student_no: studentNo })
          .then((response) => {
            const d = response.data || {};
            if (Object.keys(d).length > 0) {
              this.extraForm.student_no = d.student_no || studentNo;
              this.extraForm.hobby = d.hobby || '';
              this.extraForm.bestfriend = d.bestfriend || '';
              this.extraForm.caution = d.caution || '';
              this.extraForm.worship_attendance = d.worship_attendance || '';
              this.extraForm.class_participation = d.class_participation || '';
              this.extraForm.home_env = d.home_env || '';
              this.extraForm.student_characteristics = d.student_characteristics || '';
              this.extraForm.overall_opinion = d.overall_opinion || '';
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
      openStudentInfo(item) {
        if (!this.canEditStudent(item)) {
          this.$toast.show("해당 반의 학생만 입력/수정할 수 있습니다.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        this.currentStudentName = item.name;
        this.loadStudentExtra(item.studentid);
        $("#studentInfoModal").modal("show");
      },
      openTeacherOpinion(item) {
        if (!this.canEditStudent(item)) {
          this.$toast.show("해당 반의 학생만 입력/수정할 수 있습니다.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        this.currentStudentName = item.name;
        this.loadStudentExtra(item.studentid);
        $("#teacherOpinionModal").modal("show");
      },
      saveStudentInfo() {
        const payload = { ...this.extraForm, actor_role: this.role, actor_grade: this.grade, classid: this.classid, teacherid: this.getLoginTeacherId() };
        manageService
          .saveStudentExtra(payload)
          .then(() => {
            this.$toast.show("저장되었습니다.", {
              type: "success",
              position: "top-right",
            });
            // 저장 후 입력 필드 초기화하여 중복 저장 방지
            this.resetExtraForm();
            $("#studentInfoModal").modal("hide");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("저장에 실패했습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },
      saveTeacherOpinion() {
        const payload = { ...this.extraForm, actor_role: this.role, actor_grade: this.grade, classid: this.classid, teacherid: this.getLoginTeacherId() };
        manageService
          .saveStudentExtra(payload)
          .then(() => {
            this.$toast.show("저장되었습니다.", {
              type: "success",
              position: "top-right",
            });
            // 저장 후 입력 필드 초기화하여 중복 저장 방지
            this.resetExtraForm();
            $("#teacherOpinionModal").modal("hide");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("저장에 실패했습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },

      deletePhoto(gubun, no){
        if(no == null || no == ""){
          this.$toast.show("삭제되지 않았습니다.", {
                type: "warning",
                position: "top-right",
              });          
        }

        const idata = {
          gubun: gubun,
          no: no,
        };

        // 학년 반을 선택하세요.
        manageService
          .deletephoto(idata)
          .then((response) => {

            console.log(response.data[0]);

            console.log("phtoto=", this.photoitem);

            if(gubun == 1){
              this.photoitem.photo = null;
            }
            if(gubun == 2){
              this.photoitem.photo2 = null;
            }            

              this.$toast.show("삭제되었습니다.", {
                type: "success",
                position: "top-right",
              });
          })
          .catch((e) => {
            console.log(e);
          });
      },

      searchclassinfo(event){   //선생님을 선택하면, 학년과반을 가져와서 세팅한다.

    // 선택된 grade/gradename 값을 사용
    const selectedGrade = this.selectedClassGrade;
    const selectedOption =
      event &&
      event.target &&
      event.target.selectedOptions &&
      event.target.selectedOptions[0]
        ? event.target.selectedOptions[0]
        : null;
    const selectedGradeName = selectedOption
      ? selectedOption.dataset.gradename || ""
      : "";
    const selectedTeacherId = selectedOption
      ? selectedOption.dataset.teacherid || ""
      : "";

    this.form.groupid = null;
    this.form.grade = null;
    this.form.gradename = null;
    this.form.gradediv = null;

    // 예시로 selectedGrade를 콘솔에 출력
    console.log("Selected grade:", selectedGrade);
        const ndata = {
          grade: selectedGrade,
          gradename: selectedGradeName,
          teacherid: selectedTeacherId,
          classid: this.classid,
          role: '3',
        };

        // 학년 반을 선택하세요.
        manageService
          .searchclassinfo(ndata)
          .then((response) => {
            const row = response.data && response.data[0];
            if (!row) {
              this.form.teacherid = selectedTeacherId;
              this.form.grade = selectedGrade;
              this.form.gradename = selectedGradeName;
              this.form.gradediv = selectedGrade;
              this.form.groupid = "0";
              return;
            }
            this.classinfo = row;
            console.log(row);

            this.form.groupid = this.classinfo.groupid;
            this.form.teacherid = this.classinfo.teacherid;
            this.form.grade = this.classinfo.grade;
            this.form.gradename = this.classinfo.gradename;
            this.form.gradediv = this.classinfo.grade;
            
          })
          .catch((e) => {
            console.log(e);
          });
      },
      removemember(fform) {
        const deldata = {
          no: fform.no,
          name: fform.name,
        };

        manageService
          .memberDelete(deldata)
          .then((response) => {
            if (response.data) {
              this.$toast.show("탈퇴 처리되었습니다.", {
                type: "success",
                position: "top-right",
              });
            } else {
              this.$toast.show("취소가 실패했습니다.", {
                type: "warning",
                position: "top-right",
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });

        $("#memberDeleteModal").modal("hide");
        $("#memberAddModal").modal("hide");
        this.getMgmtAllList(this.gradegroup);
      },
      getGradeGroup() {
        this.getMgmtAllList(this.gradegroup);
      },
      getGradeGroupList() {
        const ndata = {
          classid: this.classid,
        };

        // 학년 반을 선택하세요.
        manageService
          .getGradeListAll(ndata)
          .then((response) => {
            //this.manageLists = response.data;
            this.gradegrouplist = response.data;
            console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          });
      },
      fileUpload(event) {
        const file = event.target.files[0];
        if (!file) {
          return;
        }

        const name = file.name || "";
        const ext = name.includes(".")
          ? name
              .split(".")
              .pop()
              .toLowerCase()
          : "";

        // HEIC/HEIF 등 서버에서 처리하지 않는 포맷 차단
        if (ext === "heic" || ext === "heif") {
          this.$toast.show(
            "HEIC 형식은 지원하지 않습니다. 사진을 JPG/PNG 형식으로 변환하여 업로드해주세요.",
            {
              type: "warning",
              position: "top-right",
            }
          );
          event.target.value = "";
          return;
        }

        this.fileArray.push(file);
      },
      updatePhoto(item) {
        //사진 팝업
        this.photoitem = item;
        //this.$emit('memberPhotoModal',item);
        $("#memberPhotoModal").modal("show");
      },

      savePhoto() {
        //사진 저장
        const form = new FormData();
        for (const i of Object.keys(this.fileArray)) {
          form.append("file" + i, this.fileArray[i]);
        }

        // form.append('file', this.file);
        form.append("no", this.photoitem.no);

        form.forEach(function (key, value) {
          console.log(key, value);
        });
        console.log("result=", this.fileArray.length);
        if (this.fileArray.length < 1) {
          this.$toast.show("파일을 선택해주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        manageService
          .photoUpload(form, {
            header: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((result) => {
            console.log("photoUpload result=", result);
            console.log("photoUpload result.data=", result && result.data);
            console.log("photoUpload typeof result.data=", typeof (result && result.data));
            
            const data = result && result.data;

            // 서버에서 에러 객체를 반환한 경우
            if (data && typeof data === "object" && data.error) {
              let errorMsg = "사진 업로드에 실패했습니다.\n\n";
              errorMsg += `[서버 오류]\n${data.error}\n`;
              if (this.fileArray.length > 0) {
                const file = this.fileArray[0];
                errorMsg += `\n[선택한 파일 정보]\n`;
                errorMsg += `- 파일명: ${file.name}\n`;
                errorMsg += `- 크기: ${(file.size / 1024 / 1024).toFixed(2)}MB\n`;
                errorMsg += `- 타입: ${file.type || '알 수 없음'}`;
              }
              alert(errorMsg);
              // 오류 시 모달은 닫지 않음
              return;
            }

            // 정상적인 파일명(예: "abc123.jpg")이 오면 성공 처리
            if (data && typeof data === "string" && data.length > 0) {
              // 서버에서 돌려준 새 파일명을 현재 객체에 반영해서 즉시 화면에 보이도록 함
              // photoitem 은 manageLists 안의 객체를 참조하고 있으므로,
              // 여기서 값을 바꾸면 리스트/상세 카드의 이미지도 함께 갱신됨
              this.photoitem.photo = data;

              this.$toast.show("사진이 등록되었습니다.", {
                type: "success",
                position: "top-right",
              });
              // 성공 시에만 모달 닫기
              this.closePhotoModal();
            } else {
              // 실패 시 상세 에러 메시지 표시, 모달은 열어둠
              let errorMsg = "사진 업로드에 실패했습니다.\n\n";
              errorMsg += "[허용 조건]\n";
              errorMsg += "- 허용 형식: JPG, JPEG, PNG, GIF\n";
              errorMsg += "- 최대 용량: 10MB\n";
              errorMsg += "- HEIC 형식은 지원하지 않습니다.\n";
              if (this.fileArray.length > 0) {
                const file = this.fileArray[0];
                errorMsg += `\n[선택한 파일 정보]\n`;
                errorMsg += `- 파일명: ${file.name}\n`;
                errorMsg += `- 크기: ${(file.size / 1024 / 1024).toFixed(2)}MB\n`;
                errorMsg += `- 타입: ${file.type || '알 수 없음'}`;
              }
              alert(errorMsg);
              // 오류 시 모달은 닫지 않음
            }
          })
          .catch((error) => {
            // 네트워크 오류 등 예외 처리
            console.error("photoUpload error=", error);
            let errorMsg = "사진 업로드 중 오류가 발생했습니다.\n\n";
            errorMsg += `[오류 내용]\n${error.message || '알 수 없는 오류'}\n`;
            if (error.response) {
              errorMsg += `\n[서버 응답]\n${error.response.status} ${error.response.statusText}`;
              if (error.response.data) {
                errorMsg += `\n${JSON.stringify(error.response.data)}`;
              }
            }
            if (this.fileArray.length > 0) {
              const file = this.fileArray[0];
              errorMsg += `\n\n[선택한 파일 정보]\n`;
              errorMsg += `- 파일명: ${file.name}\n`;
              errorMsg += `- 크기: ${(file.size / 1024 / 1024).toFixed(2)}MB\n`;
              errorMsg += `- 타입: ${file.type || '알 수 없음'}`;
            }
            alert(errorMsg);
            // 오류 시 모달은 닫지 않음
          });
      },
      //모달 닫기
      modalClose() {
        this.file = "";
        this.fileArray = [];
        this.formreset(); //초기화
      },
      // 사진 모달 전용 닫기 (페이지/검색 조건은 초기화하지 않음)
      closePhotoModal() {
        this.file = "";
        this.fileArray = [];
        if (this.$refs.files) {
          this.$refs.files.value = "";
        }
        $("#memberPhotoModal").modal("hide");
      },
      // 신규 추가
      AddMember() {
        this.isNew = true;

        $("#memberAddModal").modal("show");
      },
      //전체 리스트 가져오기
      getMgmtAllList(item) {
        var tempgrade = "";
        if (item == null) {
          tempgrade = this.form.grade;
        } else {
          tempgrade = item;
        }

        const idata = {
          sector: "30",
          grade: tempgrade,
          teacherid: this.form.teacherid,
          classid: this.classid,
        };

        manageService
          .getAllList(idata)
          .then((response) => {
            //this.manageLists = response.data;
            this.manageLists = response.data.slice(0, this.page);
            //console.log( this.nearMember);
            //this.manageLists = response.data;
            this.manageListLimit = response.data;
            this.pageTotalCount = Math.ceil(response.data.length / this.page);
          })
          .catch((e) => {
            console.log(e);
          });
      },
      alertMsg(msg) {
        this.$toast.show(msg, {
          type: "warning",
          position: "top-right",
        });
      },
      //팀원 등록
      setMember(division) {
        //e.preventDefault();
        // var object = {};
        // var fform = document.getElementById("addMemberform");
        // var form = new FormData(fform);
        // form.forEach(function (value, key) {
        //   object[key] = value;
        //   //console.log(key, value);
        // });
        //var jsondata = JSON.stringify(object);

        var formdata = {
          groupid: this.form.groupid,
          gradediv: this.form.gradediv,
          name: this.form.name,
          sex: this.form.sex,
          birthday: this.form.birthday,
          phone: this.form.phone,
          parentphone: this.form.parentphone,
          address: this.form.address,
          rmk: this.form.rmk,
          teacherid: this.form.teacherid,
          school: this.form.school,
          div: division,
          no: this.form.no,
          classid: this.classid,
          grade: this.form.gradediv,
          gradename: this.form.gradename,
        };

        console.log("grade=", formdata);
        if (this.form.teacherid == "" || this.form.teacherid == null) {
          this.alertMsg("선생님을 선택하세요.");
          return;
        }
        if (this.form.gradediv == "" || this.form.gradediv == null) {
          this.alertMsg("반 또는 소속이 지정되지 않았습니다.");
          return;
        }        
        // if (this.form.groupid == undefined) {
        //   this.alertMsg("학년을 선택하세요.");
        //   return;
        // }
        // if (this.form.gradediv == undefined) {
        //   this.alertMsg("반을 선택하세요.");
        //   return;
        // }
        if (this.form.name.length < 2) {
          this.alertMsg("이름을 입력하세요.");
          return;
        }
        if (this.form.sex == "" || this.form.sex == null) {
          this.alertMsg("성별을 선택하세요.");
          return;
        }
        if (this.form.name.birthday < 3 || this.form.name.birthday =="") {
          this.alertMsg("생년월일을 입력하세요.");
          return;
        }
        if (this.form.name.phone < 5) {
          this.alertMsg("연락처를 입력하세요.");
          return;
        }
        if (this.form.name.parentphone < 5) {
          this.alertMsg("학부모 연락처를 입력하세요.");
          return;
        }

        manageService
          .register(formdata)
          .then(() => {
            // console.log(response.data);
            this.$toast.show("정상적으로 등록되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getMgmtAllList(this.form.grade);
            $("#memberAddModal").modal("hide");
            this.formreset(); //초기화
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("등록되지 않았습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },
      getTeacher(param) {
        const idata = {
          grade: this.form.grade,
          teacherid: param,
          role: this.role,
          classid: this.classid,
        };

        manageService
          .getTeacherNew(idata)
          .then((response) => {
            this.teachers = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
      },
      UpdateMember(item) {
        //수정

        this.form.groupid = item.groupid;
        this.form.gradediv = item.grade;
        this.form.name = item.name;
        this.form.sex = item.sex;
        this.form.birthday = item.birthday;
        this.form.phone = item.phone;
        this.form.parentphone = item.parentphone;
        this.form.address = item.address;
        this.form.rmk = item.rmk;
        this.form.teacherid = item.teacherid;
        this.form.school = item.school;
        this.form.no = item.no;
        this.selectedClassGrade = item.grade;

        this.isNew = false;
        $("#memberAddModal").modal("show");
        console.log(item.grade);
      },
      formreset() {
        this.form.groupid = "";
        this.form.gradediv = "";
        this.form.name = "";
        this.form.sex = "";
        this.form.birthday = "";
        this.form.phone = "";
        this.form.parentphone = "";
        this.form.address = "";
        this.form.rmk = "";
        this.form.teacherid = "";
        this.selectedClassGrade = "";
        this.form.school = "";
        this.form.no = "";
      },
    },
    created() {
      if (this.role > 2) {
        this.getMgmtAllList(this.form.grade);
      }

      this.getTeacher(this.form.teacherid);
      this.getGradeGroupList();
    },
  };
</script>
